<template>
  <div
    v-if="pageCount > 0"
    class="data-table-pagination"
  >
    <button
      class="pagination-first"
      :disabled="page === 1"
      @click="page = 1"
    >
      {{ $t("First") }}
    </button>

    <button
      class="pagination-jump-back"
      :disabled="page === 1"
      @click="page = Math.max(1, page - 10)"
      :title="$t('Jump back 10 pages')"
    >
      <v-icon>mdi-chevron-double-left</v-icon>
    </button>

    <div class="pagination-center-wrapper">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="pageCount < 8 ? pageCount : 8"
        rounded
        density="comfortable"
        class="primary"
      />
    </div>

    <button
      class="pagination-jump-forward btn-fab"
      :disabled="page === pageCount"
      @click="page = Math.min(pageCount, page + 10)"
      :title="$t('Jump forward 10 pages')"
    >
      <v-icon>mdi-chevron-double-right</v-icon>
    </button>

    <button
      class="pagination-last"
      :disabled="page === pageCount"
      @click="page = pageCount"
    >
      {{ $t("Last") }}
    </button>
  </div>
</template>

<script setup lang="ts">

defineOptions({
  name: 'Pagination'
})

defineProps<{ pageCount: number }>()

const page = defineModel<number>({ name: "page", default: 1 })
</script>

<style lang="scss">
$btn-height: 34px;
$btn-min-width: 34px;
$btn-font-size: 18px;
$btn-radius: 15px;

.data-table-pagination {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 10px auto;
  //overflow: hidden;
  justify-content: center;

  .pagination-first,
  .pagination-last,
  .pagination-jump-back,
  .pagination-jump-forward,
  .v-pagination .v-btn {
    height: $btn-height;
    min-width: $btn-min-width;
    font-size: $btn-font-size;
    font-weight: 500;
    border-radius: $btn-radius;
    background: transparent;
    border: 1px solid transparent;
    transition: all 0.2s ease;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: rgb(var(--v-theme-primary));

    &:hover:not(:disabled) {
      background-color: rgba(var(--v-theme-primary), 0.08);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      color: rgb(var(--v-theme-black-30));
    }
  }

  .pagination-center-wrapper {
    display: contents;
    flex-wrap: wrap;
  }

  .v-pagination {
    flex-shrink: 0;
    .v-pagination__list {
      display: flex;
      gap: 4px;
      padding: 0;
      margin: 0;
      align-items: center;
    }
    .v-pagination__item {
      margin: 0;
    }
    .v-btn {
      height: $btn-height !important;
      min-width: $btn-min-width !important;
      font-size: $btn-font-size !important;
      border-radius: $btn-radius !important;
      color: rgb(var(--v-theme-primary)) !important;
      padding: 0 5px !important;
      --v-btn-height: initial !important;
    }
    .v-pagination__item--is-active .v-btn {
      background-color: rgb(var(--v-theme-primary)) !important;
      color: #fff !important;
    }
    .v-btn--disabled {
      opacity: 0.5;
      color: rgb(var(--v-theme-black-30)) !important;
    }

    .v-pagination__prev,
    .v-pagination__next {
      .v-btn {
        padding: 0 !important;
        padding-inline: 0 !important;
      }
    }
  }
}
</style>
